import { apiLogin } from "@/api";

const TOKEN_KEY = "ac_token";
const USER_KEY = "ac_user";

function loadInitial() {
  let token = null, user = null;
  try { token = localStorage.getItem(TOKEN_KEY) || null; } catch {}
  try { user = JSON.parse(localStorage.getItem(USER_KEY) || "null"); } catch {}
  return { token, user };
}

export default {
  namespaced: true,
  state: () => ({
    ...loadInitial(),
    // optional: for refresh flows later
    refreshing: false,
  }),
  getters: {
    isAuthenticated: (s) => !!s.token,
    user: (s) => s.user,
    token: (s) => s.token,
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      try {
        if (token) localStorage.setItem(TOKEN_KEY, token);
        else localStorage.removeItem(TOKEN_KEY);
      } catch {}
    },
    SET_USER(state, user) {
      state.user = user;
      try {
        if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
        else localStorage.removeItem(USER_KEY);
      } catch {}
    },
    LOGOUT(state) {
      state.token = null;
      state.user = null;
      try {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
      } catch {}
    },
  },
  actions: {
    async login({ commit }, { usuario, password }) {
      // Expecting backend returns { access_token, token_type, user }
      const data = await apiLogin(usuario, password);
      commit("SET_TOKEN", data.access_token);
      commit("SET_USER", data.user || null);
      return data;
    },
    logout({ commit }) {
      commit("LOGOUT");
    },
  },
};
